"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function ProcessSection() {
  const { t } = useLanguage();

  const steps = [
    {
      num: "1",
      titleKey: "sliding.process1Title",
      descKey: "sliding.process1Desc",
    },
    {
      num: "2",
      titleKey: "sliding.process2Title",
      descKey: "sliding.process2Desc",
    },
    {
      num: "3",
      titleKey: "sliding.process3Title",
      descKey: "sliding.process3Desc",
    },
    {
      num: "4",
      titleKey: "sliding.process4Title",
      descKey: "sliding.process4Desc",
    },
  ];

  return (
    <section className="bg-white py-20 px-4 md:px-6">
      <div className="max-w-[1080px] mx-auto">
        <h2 className="text-2xl md:text-[32px] font-bold text-[#064e3b] text-center mb-12">
          {t("sliding.processH2")}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((s) => (
            <div key={s.num} className="text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-[#047857] text-white font-bold text-lg mb-4">
                {s.num}
              </div>
              <h3 className="text-base font-bold text-[#064e3b] mb-2">{t(s.titleKey)}</h3>
              <p className="text-sm text-gray-600">{t(s.descKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}